// =============================================================================
// resourceHtml.ts — defensive sanitiser for supervisor-authored Resources HTML
// =============================================================================
// Resource pages are rich HTML authored with the Quill editor and rendered via
// dangerouslySetInnerHTML. The author is a trusted Supervisor and Quill emits a
// safe subset, so this is DEFENSE-IN-DEPTH (mirrors
// crm/compose/emailHtml.sanitizeBodyHtml), not a full whitelist parser: strip
// dangerous elements, inline event handlers, and javascript: URLs. Applied on
// save AND on display.
// =============================================================================

const DANGEROUS_OPEN =
  /<\s*(script|style|iframe|object|embed|link|meta|form|input|button|textarea|select)\b[^>]*>/gi;
const DANGEROUS_CLOSE =
  /<\s*\/\s*(script|style|iframe|object|embed|form|input|button|textarea|select)\s*>/gi;

export function sanitizeResourceHtml(html: string): string {
  let out = String(html ?? "");
  out = out.replace(DANGEROUS_OPEN, "");
  out = out.replace(DANGEROUS_CLOSE, "");
  // Inline event handlers (onclick=, onerror=, …) in any quoting style.
  out = out.replace(/\son\w+\s*=\s*"[^"]*"/gi, "");
  out = out.replace(/\son\w+\s*=\s*'[^']*'/gi, "");
  out = out.replace(/\son\w+\s*=\s*[^\s>]+/gi, "");
  // Neutralise javascript: URLs on href/src.
  out = out.replace(/(href|src)\s*=\s*"\s*javascript:[^"]*"/gi, '$1="#"');
  out = out.replace(/(href|src)\s*=\s*'\s*javascript:[^']*'/gi, "$1='#'");
  return out;
}
